<template>
  <div class="records-container">
    <el-card class="records-card1">
      <div class="main-header">
        <div class="main-header-left">
          <span>{{$t('records')}}</span>
        </div>
        <div class="main-header-right" >
          <button class="print" @click="print">{{$t('print')}}</button>
        </div>
      </div>
      <hr class="small-hr">
      <div class="content">
        <p>{{$t('Profile')}}:</p>
        <table>
          <tr class="header"><td>{{$t('uername')}}</td><td>{{$t('Name')}}</td><td>{{$t('Age')}}</td>
            <td>{{$t('height')}}</td><td>{{$t('weight')}}</td><td>{{$t('disType')}}</td><td>{{$t('Duration')}}</td>
          </tr>
          <tr><td>{{profile.username}}</td><td>{{profile.name}}</td><td>{{profile.birthday}}</td><td>{{profile.height}}</td>
            <td>{{profile.weight}}</td><td>{{profile.diabetes_type}}</td><td>{{profile.diabetes_diagnosis_date}}</td></tr>
        </table>
      </div>
      <div class="content">
        <p>{{$t('Complications')}}:</p> <button class="print print1" @click = "create1" v-show="(userType!=='P')">{{$t('Create')}}</button>
        <table>
          <tr class="header"><td >{{$t('Concomitant diseases')}}</td><td>{{$t('disDate')}}</td>
            <td>{{$t('Suggestion')}}</td><td v-show="(userType!=='P')">{{$t('Action')}}</td></tr>
          <tr v-for="(item,index) in complications" :class="(index%2===0) ? '':'even'" :id="index"><td>{{item[1]}}</td><td>{{item[2]}}</td>
            <td class="cntW">{{item[3]}}</td><td v-show="(userType!=='P')"><span class="action" @click="edit1">{{$t('edit')}}</span><br>
              <span class="action" @click="delete1">{{$t('Delete')}}</span></td>
          </tr>
        </table>
      </div>
      <div class="content" v-cloak>
        <p>{{$t('Prescription')}}:</p>  <button class="print print1" @click = 'create2' v-show="(userType!=='P')">{{$t('Create')}}</button>
        <table>
          <tr class="header"><td>{{$t('Medicine')}}</td><td>{{$t('Dose')}}</td><td>{{$t('Notes')}}</td>
            <td v-show="(userType!=='P')">{{$t('Action')}}</td></tr>
          <tr v-for="(item,index) in prescription" :class="(index%2===0) ? '':'even'" :id="index"><td>{{item[1]}}</td><td>{{item[2]}}</td>
            <td class="cntW">{{item[3]}}</td><td v-show="(userType!=='P')">
              <span class="action" @click="edit2">{{$t('edit')}}</span><br><span  class="action" @click="delete2">{{$t('Delete')}}</span></td>
          </tr>
        </table>
      </div>
      <div class="content">
        <p>{{$t('Other suggestions')}}:</p>
        <button class="print print1" @click = 'create3' v-show="(userType!=='P')">{{$t('Create')}}</button>
        <div class="time" :class="{'zh1':!isEn}">
          <span>{{$t('From')}}</span>
          <div class="block">
            <el-date-picker v-model="value2" type="date"  :editable=false   :picker-options="pickerOptions"
                            :clearable=false    :placeholder="defaultDate"    format="dd-MM-yyyy" >
            </el-date-picker>
          </div>
          <span class="to">{{$t('To')}}</span>
          <div class="block">
            <el-date-picker v-model="value1" type="date"  :editable=false   :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
        </div>
        <table>
          <tr class="header"><td>{{$t('HCP')}}</td><td>{{$t('date')}}</td><td>{{$t('Suggestion')}}</td>
            <td v-show="(userType!=='P')">{{$t('Action')}}</td></tr>
          <tr v-for="(item,index) in suggestions" :class="(index%2===0) ? '':'even'" :id="index"><td>{{item[3]}}</td><td>{{item[1]}}</td>
            <td class="cntW">{{item[2]}}</td><td v-show="(userType!=='P')">
              <span  class="action" @click="edit3">{{$t('edit')}}</span><br><span  class="action" @click="delete3">{{$t('Delete')}}</span></td>
          </tr>
        </table>
      </div>
    </el-card>

    <!--Add对话框-->
    <el-dialog  :visible.sync="CreateVisible" :size=dialogSize class="dialog-form2" :show-close="false">
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('Create')}}</span>
        <img src="../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div v-show="typeA">
          <div class="cont" :class="{'es1':isEs}">
            <span :class="{'de1':isDe,'it1':isIt,'cz1':isCz}">{{$t('Concomitant diseases')}}</span>
           <input class="dis" v-model="t1" maxlength="20" :class="{'zh2':!isEn}" :placeholder="tip0">
          </div>
          <div class="cont"  :class="{'es1':isEs}">
               <span class="date" :class="{'es2':isEs,'de2':isDe,'du2':isDu,'fr2':isFr,'sw2':isSw}">{{$t('disDate')}}</span>
               <div class="block">
                   <el-date-picker v-model="value3" type="date"  :editable=false   :picker-options="pickerOptions"
                                   :clearable=false  :placeholder="Time"    format="dd-MM-yyyy">
                   </el-date-picker>
               </div>
          </div>
          <div class="cont">
            <span>{{$t('Suggestion')}}</span>
            <input class="sugg"  :class="{'zh3':!isEn,'de3':isDe,'it3':isIt,'po3':isPo,'du3':isDu,'fr3':isFr,'sw3':isSw,'cz3':isCz}" type="text" :placeholder="tip1" v-model="t2" :maxlength="40">
          </div>
        </div>
        <div v-show="typeB">
          <div class="cont">
            <span>{{$t('Medicine')}}</span>
            <input class="medic" :class="{'zh4':!isEn,'it4':isIt,'du4':isDu,'cz4':isCz}" type="text" :placeholder="tip3" v-model="t3" :maxlength="20">
          </div>
          <div class="cont">
            <span>{{$t('Dose')}}</span>
            <input  class="dose1"  :class="{'es5':isEs,'de4':isDe,'it5':isIt,'fr4':isFr,'sw4':isSw}" type="text" :placeholder="tip2" v-model="t4" :maxlength="20">
          </div>
          <div class="cont">
            <span>{{$t('Notes')}}</span>
            <input class="sug1"   :class="{'zh5':!isEn,'de5':isDe,'du5':isDu,'fr5':isFr,'sw5':isSw,'cz5':isCz}" type="text" :placeholder="tip4"  v-model="t5" :maxlength="40">
          </div>
        </div>
        <div v-show="typeC">
          <div class="cont">
            <span>{{$t('HCP')}}</span>
            <span  class="hcp" v-model="t6"  :class="{'zh7':!isEn,'es7':isEs,'du7':isDu,'cz7':isCz}">{{username}}</span>
          </div>
          <div class="cont">
            <span  style="margin-right: 73px;" class="date"  :class="{'zh8':!isEn,'po8':isPo||isDu||isFr}">{{$t('date')}}</span>
            <span class="now" :class="{'de8':isDe,'po9':isPo}" v-model="value4">{{now}}</span>
          </div>
          <div class="cont">
            <span class="long-span">{{$t('Content')}}</span>
            <textarea class="textArea"  type="text"  :placeholder="tip5" v-model="t7" :class="{'zh6':!isEn,'it7':isIt,'cz8':isCz}" maxlength="1000">
            </textarea>
          </div>
        </div>
        <hr class="patientList-small-hr">
      </div>

      <div slot="footer" class="dialog-footer">
        <button  @click="createRecord1" v-show="typeA">{{$t('save')}}</button>
        <button  @click="createRecord2" v-show="typeB">{{$t('save')}}</button>
        <button  @click="createRecord3" v-show="typeC">{{$t('save')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>

    <!--Edit对话框-->
    <el-dialog  :visible.sync="EditVisible" :size=dialogSize class="dialog-form2" :show-close="false">
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('edit')}}</span>
        <img src="../assets/cancel.png" @click="cancel1">
      </div>
      <div slot class="dialog-body">
        <div v-show="typeA1">
          <div class="cont" :class="{'es1':isEs}">
            <span :class="{'de1':isDe,'it1':isIt,'cz1':isCz}">{{$t('Concomitant diseases')}}</span>
            <input class="dis"  type="text"   :placeholder="tip0" v-model="edNote0" :class="{'zh2':!isEn}" maxlength="40">
          </div>
          <div class="cont" :class="{'es1':isEs}">
            <span class="date" :class="{'es2':isEs,'de2':isDe,'du2':isDu,'fr2':isFr,'sw2':isSw}">{{$t('disDate')}}</span>
            <div class="block">
              <el-date-picker v-model="value5" type="date"  :editable=false   :picker-options="pickerOptions"
                              :clearable=false    :placeholder="comp[2]"    format="dd-MM-yyyy">
              </el-date-picker>
            </div>
          </div>
          <div class="cont">
            <span>{{$t('Suggestion')}}</span>
            <input class="sugg" type="text"  :placeholder="tip1"  v-model="edNote1" :class="{'zh3':!isEn,'de3':isDe,'it3':isIt,'po3':isPo,'du3':isDu,'fr3':isFr,'sw3':isSw,'cz3':isCz}" maxlength="40">
          </div>
        </div>
        <div v-show="typeB1">
          <div class="cont">
            <span>{{$t('Medicine')}}</span>
            <input class="medic" type="text" :placeholder="tip3" v-model="edNote2" :class="{'zh4':!isEn,'it4':isIt,'du4':isDu,'cz4':isCz}" maxlength="20">
          </div>
          <div class="cont">
            <span>{{$t('Dose')}}</span>
            <input class="dose1"  :class="{'es5':isEs,'de4':isDe,'it5':isIt,'fr4':isFr,'sw4':isSw}" type="text" :placeholder="tip2" v-model="edNote3" maxlength="20">
          </div>
          <div class="cont">
            <span>{{$t('Notes')}}</span>
            <input class="sug1" type="text" :placeholder="tip4" v-model="edNote4" :class="{'zh5':!isEn,'de5':isDe,'du5':isDu,'fr5':isFr,'sw5':isSw,'cz5':isCz}" maxlength="40">
          </div>
        </div>
        <div v-show="typeC1">
          <div class="cont">
            <span>{{$t('HCP')}}</span>
            <span class="hcp"  v-model="sug[3]" :class="{'zh7':!isEn,'es7':isEs,'du7':isDu,'cz7':isCz}">{{sug[3]}}</span>
          </div>
          <div class="cont">
            <span  style="margin-right: 73px;" class="date"  :class="{'zh8':!isEn,'po8':isPo||isDu||isFr}">{{$t('date')}}</span>
            <span  class="now" :class="{'de8':isDe,'po9':isPo}" v-model="value6">{{now}}</span>
          </div>
          <div class="cont">
            <span class="long-span">{{$t('Content')}}</span>
            <textarea class="textArea"  type="text" :placeholder="tip5" v-model="edNote5" :class="{'zh6':!isEn,'it7':isIt,'cz8':isCz}" maxlength="1000">
            </textarea>
          </div>
        </div>
        <hr class="patientList-small-hr">
      </div>

      <div slot="footer" class="dialog-footer">
        <button  @click="editRecords1" v-show="typeA1">{{$t('save')}}</button>
        <button  @click="editRecords2" v-show="typeB1">{{$t('save')}}</button>
        <button  @click="editRecords3" v-show="typeC1">{{$t('save')}}</button>
        <button  class="cancelButton" @click="cancel1">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../auth/auth'
import format from '@/lib/format'
  import B64 from '../auth/base64'
  export default{
    data(){
      return{
        value1:'',value2:'',defaultDate:'17-8-2017',value3:'',value4:'',value5:'',value6:'',uid:0,maxlength:40,isIt:false,
        t1:'',t2:'',t3:'',t4:'',t5:'',t6:'',t7:'', userType:'',username:'',now:'',isCz:false,
        isEn:false,isEs:false,Time:this.$t('time'),isDe:false,isPo:false,isDu:false,isFr:false,isSw:false,
        tip0:this.$t('Enterdis'),
        tip1:this.$t('Enter suggestion'),
        tip2:this.$t('Enter dose'),
        tip3:this.$t('Enter medicine'),
        tip4:this.$t('Add note'),
        tip5:this.$t('Add Content'),


        profile:{},complications:[],prescription:[],suggestions:[],
        comp:[],compl:[],pre:[],sug:[],dialogSize:'tiny',

        CreateVisible:false,typeA:false,typeB:false,typeC:false,
        EditVisible:false,typeA1:false,typeB1:false,typeC1:false,

        edNote1:"", edNote2:"", edNote3:"", edNote4:"", edNote5:"",  edNote0:"",

        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        dis:["CORONARY_HEART_DISEASE", "HIGH_BLOOD_LIPIDS", "HIGH_BLOOD_PRESSURE", "KIDNEY_DISEASE", "NEUROPATHY",
         "OBESITY", "PERIPHERAL_ARTERIAL_DISEASE", "RETINOPATHY", "SMOKING_ADDICTION"]
      }
    },
    methods:{
      cancel(){
        this.CreateVisible=false;
      },
      create1(){
        this.CreateVisible=true;
        this.typeA = true;
        this.typeB = false;
        this.typeC = false;
        this.t2='';
        this.t1='';
      },
      create2(){
        this.CreateVisible=true;
        this.typeB = true;
        this.typeA = false;
        this.typeC = false;
        this.t3='';this.t4='';this.t5='';
      },
      create3(){
        this.CreateVisible=true;
        this.typeC = true;
        this.typeA = false;
        this.typeB = false;
        this.t7='';
      },
      createRecord1(){
        let comp= [];
        comp[1] = this.t1;
        comp[2] = this.t2;
        let time1 = (this.value3)?this.value3.getTime()/1000:'';
        comp[0] = time1;
        let data = {
          complications:[comp],
        } ;
        if(comp[1]&&comp[0]){
          auth.newRecords(this,this.uid,data);
        }else{
            alert('Concomitant disease and Date of diagnosis is required!');
        }
      },
      createRecord2(){
        let pre=[];
        pre[0] = this.t3;
        pre[1] = this.t4;
        pre[2] = this.t5;
        let data = {
          prescription:[pre],
        } ;
        if(pre[1]&&pre[0]){
          auth.newRecords(this,this.uid,data);
        }else{
          alert('Medicine and Dose is required!');
        }
      },
      createRecord3(){
        let sug=[];
        sug[1] = this.t7;
        sug[2] = this.t6;//未用上
        let time1 = new Date().getTime()/1000;
        sug[0] = time1;
        let data = {
          suggestions:[sug],
        } ;
        if(sug[1]){
          auth.newRecords(this,this.uid,data);
        }else{
           alert('Input content')
        }
      },

      delete1(e){
        let tip = this.$t('deleteThis');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Yes');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(() => {
            let index = e.target.parentNode.parentNode.id;
            let eid = this.complications[index][0];
            let eids = [];
            eids.push(eid);
            let rids = {
              complications:eids,
              prescription:[],
              suggestions:[],
            } ;
            auth.deleteRecords(this,this.uid,rids);
          },function () {

          });
      },
      delete2(e){
        let tip = this.$t('deleteThis');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Yes');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
        }).then(() => {
          let index = e.target.parentNode.parentNode.id;
          let eid = this.prescription[index][0];
          let eids = [];
          eids.push(eid);
          let rids = {
            complications:[],
            prescription:eids,
            suggestions:[],
          } ;
          auth.deleteRecords(this,this.uid,rids);
        },function () {

        });
      },
      delete3(e){
        let tip = this.$t('deleteThis');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Yes');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
        }).then(() => {
          let index = e.target.parentNode.parentNode.id;
          let eid = this.suggestions[index][0];
          let eids = [];
          eids.push(eid);
          let rids = {
            suggestions:eids,
          } ;
          auth.deleteRecords(this,this.uid,rids);
        },function () {

        });
      },

      cancel1(){
        this.EditVisible=false;
      },
      edit1(e){
        let index = e.target.parentNode.parentNode.id;
        this.comp = this.complications[index];
        this.edNote0 = this.comp[1];
        this.edNote1 = this.comp[3];
        this.EditVisible=true;
        this.typeA1 = true;
        this.typeB1 = false;
        this.typeC1 = false;
      },
      edit2(e){
        let index = e.target.parentNode.parentNode.id;
        this.pre = this.prescription[index];
        this.edNote2 =this.pre[1];
        this.edNote3 =this.pre[2];
        this.edNote4 =this.pre[3];
        this.EditVisible=true;
        this.typeB1 = true;
        this.typeA1 = false;
        this.typeC1 = false;
      },
      edit3(e){
        let index = e.target.parentNode.parentNode.id;
        this.sug = this.suggestions[index];
        this.edNote5 =this.sug[2];
        this.EditVisible=true;
        this.typeC1 = true;
        this.typeB1 = false;
        this.typeA1 = false;
      },
      editRecords1(){
        let comp= [];
        comp[0] = this.comp[0];
        let day =this.comp[2].split('-');
        let isEn = (sessionStorage.getItem('language')!=='zh')?true:false;
        let day2 =(isEn)? day[2]+'-'+day[1]+'-'+day[0]:day[0]+'-'+day[1]+'-'+day[2];
        let second = new Date(day2).getTime()/1000-3600*8;
        let time1 = (this.value5)?this.value5.getTime()/1000:second;
        comp[1] = time1;
        comp[2] = this.edNote0;
        comp[3] = this.edNote1;
        let data = {
          complications:comp,
        } ;
        auth.editRecords(this,this.uid,data);
      },
      editRecords2(){
        let pre= [];
        pre[0] = this.pre[0];
        pre[1] = this.edNote2;
        pre[2] = this.edNote3;
        pre[3] = this.edNote4;
        let data = {
          prescription:pre,
        } ;
        if(pre[1]&&pre[2]){
            auth.editRecords(this,this.uid,data);
        }else{
          alert('Medicine and Dose is required!');
        }
      },
      editRecords3(){
        let sug= [];
        sug[0] = this.sug[0];
        let time1 = new Date().getTime()/1000;
        sug[1] = time1;
        sug[2] = this.edNote5;
        let data = {
          suggestions:sug,
        } ;
        if(sug[2]){
          auth.editRecords(this,this.uid,data);
        }else{
          alert('Input content')
        }
      },

      print(){
        window.open('/#/record-print','_blank');
      }

    },
    mounted:function () {
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.userType = sessionStorage.getItem('userType');
      this.username =sessionStorage.getItem('username');
      let isEn = (lang!=='zh')?true:false;
      this.now = (isEn)?format.formatterDate4(new Date().getTime()/1000):format.formatterDate3(new Date().getTime()/1000);
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      auth.getRecords(this,this.uid);
    }
  }
</script>

<style scoped>
  [v-cloak]{
    display: none;
  }
  .records-container{
    height:100%;
    width:100%;
    background:#fafbfc;
    font-size: 18px;
    color:#282828;
    letter-spacing:-0.44px;
    font-family:SFUIText-Regular;
    padding-top: 20px;
  }
  .records-card1{
    width: 97%;
    margin: 0 auto;
    min-height:750px;
  }
  .print-card1 select{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    padding-left: 10px;
  }
  .main-header{
    width:97%;
    height:40px;
    margin:0 auto;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
   .print{
    float:right;
    background: transparent;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
    box-shadow: none;
    border-radius:100px;
    width: 120px;
    height: 26px;
    font-family:SFUIText-Regular;
    font-size:16px;
     cursor: pointer;
  }
   .print1:hover{
     background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
   }

  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }

  .content{
    width: 97%;
    margin:0 auto;
    min-height: 130px;
  }
  .content p{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#0082d2;
    letter-spacing:-0.44px;
    margin-left: 1%;
    margin-bottom: 10px;
    display: inline-block;
  }
  .content .print{
    margin-bottom: 5px;
  }
  .time{
    float:right;
    margin-top: -4px;
    margin-bottom: 10px;
    margin-right: 4%;
  }
  .time span{
    display: block;
    float:left;
    margin-right: 20px;
    height:35px;
    line-height: 35px;
  }
   .zh1 span{
    font-size: 16px;
  }

  .time .to{
    margin:0 20px;
  }
  .time .block{
    float: left;
  }
  .el-date-editor.el-input{
    width:130px;
    height:33px;
  }

  /*表格*/
  table{
    width:100%;
    table-layout: fixed;
    font-family:SFUIText-Regular;
    font-size:16px;
    color: #282828;
    letter-spacing:-0.44px;
    text-align:center;
    border-collapse: collapse;
    margin-bottom: 20px;
    margin-top: 5px;
    word-break: break-all;
    word-wrap: break-word;
  }
  table .header{
    color:#005dac;
    height:36px;
    background:#cfdff0;
    font-size:18px;
  }
  tr{
    height: 50px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }
  table .cntW{
    text-align: center;
  }
  .even{
    background:#ebeef1;
  }

  /*对话框*/
  .dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .cont{
    width: 92%;
    margin-left: 8%;
    margin-bottom: 20px;
  }
  .cont span{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .cont select{
    width: 50%;
    height: 37px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    padding-left: 8px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
  }
  .cont .dis{
    margin-left:10px;
  }
  .cont .zh2{
    margin-left: 55px;
  }
  .cont .date{
    margin-right: 44px;
    float: left;
    display: inline-block;
    margin-top: 5px;
  }
  .cont .now{
    margin-left: 2px;
  }
  .cont .zh8{
    margin-top: -2px;
  }
  .cont .po8{
    margin-top: -2px;
  }
  .el-date-editor.el-input{
    width:125px;
    color:#6d6d6d;
  }
  .action{
    cursor: pointer;
    color:#0082d2;
  }

  .cont input{
    margin-left: 77px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width: 48%;
    height: 34px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
  }
  .cont .sugg{
    margin-bottom: 15px;
    margin-left: 70px;
  }
  .cont .medic{
    margin-left: 58px;
  }
  .cont .zh4{
    margin-left: 51px;
  }
  .cont .sug1{
    margin-bottom: 15px;
    margin-left: 78px;
  }
  .cont .dose1{
    margin-left: 83px;
  }
  .cont .es5{
    margin-left: 81px;
  }
  .cont .zh3{
    margin-left: 71px;
  }
  .cont .zh5{
    margin-left: 83px;
  }

  .cont .long-span{
    float: left;
  }
  .textArea{
    margin-left: 51px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    height:120px;
    width:65%;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
    padding-left: 8px;
    resize: none;
  }
  .hcp{
    margin-left: 72px;
  }
  .zh7{
    margin-left: 42px;
  }
  .es7{
    margin-left: 83px;
  }
  .cont .zh6{
    margin-left: 75px;
  }
  .es1 span{
    width: 70px;
    float: left;
    display: inline-block;
    margin-right: 68px;
  }
  .es1 .es2{
   margin-top: 0;
    margin-right: 77px;
  }
  .cont .de1{
    margin-right: 21px;
  }
  .cont .de2{
    margin-right: 17px;
  }
  .cont .de3{
    margin-left: 89px;
  }
  .cont .de4{
    margin-left: 72px;
  }
  .cont .de5{
    margin-left: 59px;
  }
  .cont .de7{
    margin-right: 90px;
  }
  .cont .de8{
    margin-left: -15px;
  }
  .cont .po9{
    margin-left: 15px;
  }
  .cont .it1{
    margin-right: 16px;
  }
  .cont .it3{
    margin-left: 78px;
  }
  .cont .it4{
    margin-left: 38px;
  }
  .cont .it5{
    margin-left: 75px;
  }
  .cont .it7{
    margin-left: 34px;
  }
  .cont .po3{
    margin-left: 108px;
  }

  .cont .du2{
    margin-right: 82px;
  }
  .cont .du3{
    margin-left: 116px;
  }
  .cont .du4{
    margin-left: 65px;
  }
  .cont .du5{
    margin-left: 30px;
  }
  .cont .du7{
    margin-left: 30px;
  }

  .cont .fr2{
    margin-right: 51px;
  }
  .cont .fr3{
    margin-left: 95px;
  }
  .cont .fr4{
    margin-left: 106px;
  }
  .cont .fr5{
    margin-left: 65px;
  }

  .cont .sw2{
    margin-right: 53px;
  }
  .cont .sw3{
    margin-left: 98px;
  }
  .cont .sw4{
    margin-left: 95px;
  }
  .cont .sw5{
    margin-left: 42px;
  }

  .cont .cz1{
    margin-right: 28px;
  }
  .cont .cz3{
    margin-left: 109px;
  }
  .cont .cz4{
    margin-left: 100px;
  }
  .cont .cz5{
    margin-left: 55px;
  }
  .cont .cz7{
    margin-left: 25px;
  }
  .cont .cz8{
    margin-left: 65px;
  }

  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
    font-family:SFUIText-Regular;
    font-size:15px;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }
</style>



// WEBPACK FOOTER //
// records.vue?69a48d1c